<template>
    <div class="" id="">
        <section class="modal_back_caa">
            <ProgressCards :show-counterpart-card="counterpart.obligation_name != 'finiquitos-clf'"
                :classified-by-counterpart="getNumberClassifiedByCounterpart"
                :classified-by-document="getNumberClassifiedByDocument" :total="getNumberTotalDocuments" />

            <div class="is-flex is-flex-direction-row is-flex-grow-1 mb-3">
                <div class="is-flex-grow-2">
                    <div class="header_title">
                        {{ readOnly ? 'Documentos' : 'Clasificar por documentos' }}
                    </div>
                    <div class="header_subtitle">
                        {{ readOnly
                            ? 'Detalle del libro mayor por documento (solo lectura)'
                            : 'Clasifica de forma individual o por lotes para mayor eficiencia' }}
                    </div>
                </div>
            </div>

            <DocsFilterToolbar :search-value.sync="searchFilter" :active-filter="filterTable"
                @select-filter="onSelectFilter" />

            <div class="container_table_main_table main_table">
                <table class="big_table color_gray_text">
                    <colgroup>
                        <col v-if="!readOnly" style="width: 3%" />
                        <col v-for="header in selectedHeaderDocsTable.headers" v-bind:key="header.key"
                            :style="'width: ' + header.width + '%;'" />
                        <col v-if="!readOnly" style="width: 2%" />
                    </colgroup>
                    <tr>
                        <td v-if="!readOnly" class="py-3 px-2 ">
                            <div class="mt-1 ml-2 checkboxes is-clickable">
                                <label for="allSelected">
                                    <input class="checkSize" type="checkbox" @change="onChangeAllCheck($event.target)"
                                        v-model="allSelected" name="allSelected" id="allSelected">
                                </label>
                            </div>
                        </td>
                        <td class="py-3 px-2 is-vcentered" v-for="header in selectedHeaderDocsTable.headers"
                            v-bind:key="header.label">
                            <span class="table_header_title ml-2 is-justify-content-center nobreak"
                                :class="{ sortable_header: header.key }"
                                @click="header.key && changeOrderGeneric(header.key)">
                                <span class="header_label">{{ header.label }}</span>
                                <!-- Indicador de orden: siempre presente y sin encogerse, para
                                    que etiquetas largas en columnas angostas no lo tapen. El click
                                    lo maneja el header completo (burbujea desde el botón). -->
                                <SortButton class="ml-1 sort_btn"
                                    :globalSortColumn="sortColumn" :column="header.key" :sortDirection="sortDirection">
                                </SortButton>
                            </span>
                        </td>
                        <td v-if="!readOnly"></td>
                    </tr>
                    <template v-for="(entry, iEntry) in getPaginatedList">
                        <tr :class="['counterpart_row', { 'is-disabled-local': entry.cancelled, 'is-classifying': entry.isClassifying }]"
                            v-show="entry.visible" v-bind:key="entry.td_id">
                            <td v-if="!readOnly" class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="mt-1 ml-2 checkboxes">
                                    <label for="selected">
                                        <input class="checkSize is-clickable" type="checkbox" v-model="entry.selected"
                                            name="selected" id="selected" :disabled="entry.cancelled">
                                    </label>
                                </div>
                            </td>


                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <span class="nobreak is-capitalized attribute_name">
                                    {{
                                        getFormattedDate(entry.emitted_at,
                                            selectedHeaderDocsTable.headers[0].formatDate).replace('.', '')
                                    }}
                                </span>
                                <!-- Vista acumulada: empresa de origen del documento
                                     + badge cuando la contraparte es otro miembro
                                     (el doc aparece dos veces en el grupo). -->
                                <div v-if="isConsolidatedCompany && entry.owner_name" class="doc-owner">
                                    {{ entry.owner_name }}
                                    <span
                                        v-if="entry.is_intercompany"
                                        class="intercompany-badge"
                                        title="La contraparte también es miembro de la empresa consolidada: este documento aparece dos veces (venta en una, compra en la otra)."
                                    >intercompañía</span>
                                </div>
                            </td>

                            <td class="py-3 px-2 is-vcentered"
                                :class="{ 'is-disabled-local': !readOnly && entry.accounts.length == 0, 'is-clickable': (!readOnly && entry.accounts.length > 0) || (readOnly && entry.has_accrual) }"
                                @click="openAccrualModal(iEntry)">
                                <div class="is-flex is-justify-content-center" v-if="!entry.has_accrual">
                                    <span class="is-capitalized nobreak attribute_name is-align-content-center">
                                        {{
                                            getFormattedDate(entry.emitted_at,
                                                selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                        }}
                                    </span>
                                    <span v-if="!readOnly">
                                        <CalendarMinus class="iconAlign" />
                                    </span>
                                </div>

                                <div v-else class="is-flex is-flex-direction-row is-justify-content-center">
                                    <span class="mr-2 attribute_name">
                                        <p class="is-capitalized"> {{
                                            getFormattedDate(entry.init_accrual,
                                                selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                        }}
                                        </p>
                                        <p v-if="entry.init_accrual != entry.end_accrual" class="is-capitalized">
                                            {{
                                                getFormattedDate(entry.end_accrual,
                                                    selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                            }}
                                        </p>
                                    </span>
                                    <span class="is-align-self-center">
                                        <CalendarCheck class="iconAlign" />
                                    </span>
                                </div>
                            </td>

                            <template v-for="(header, iHeader) in selectedHeaderDocsTable.headers">
                                <td v-if="iHeader > 1 && !['mother_account', 'accounts', 'attribute'].includes(header.key)"
                                    v-bind:key="header.label"
                                    class="py-3 px-2 is-vcentered has-text-centered attribute_name">
                                    <span v-if="header.key == 'amount'">{{ money(entry.amount) }}</span>
                                    <span v-else>{{ entry[header.path] }}</span>
                                </td>
                            </template>

                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="square_pill pill_sin_clasificar nobreak"
                                    v-if="!entry.accounts || !entry.accounts.length || entry.cancelled">
                                    <span v-if="!entry.cancelled">Sin Clasificar</span>
                                    <span v-if="entry.cancelled && entry.doc_type != 'Boleta de Honorarios'">
                                        Anulado por NC: {{ entry.nc_doc_number }}
                                    </span>
                                    <span v-if="entry.cancelled && entry.doc_type == 'Boleta de Honorarios'">
                                        Anulada
                                    </span>
                                </div>
                                <div v-if="!entry.cancelled" class="is-vcentered has-text-centered">
                                    <span class="square_pill pill_mother_account grey_pill nobreak d"
                                        v-for="(mother_account, index) in entry.mother_accounts" v-bind:key="index"
                                        v-tooltip.top="labelTooltip(mother_account)">
                                        {{ truncateLabel(mother_account) }}
                                    </span>
                                </div>

                            </td>

                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="is-flex is-flex-direction-row is-justify-content-center is-flex-wrap-wrap">
                                    <div class="square_pill pill_mother_account white_pill nobreak"
                                        v-for="account in entry.accounts" v-bind:key="account.level_3"
                                        v-tooltip.top="labelTooltip(account.level_3)">
                                        {{ truncateLabel(account.level_3) }}
                                    </div>
                                    <div v-if="!readOnly && !entry.cancelled && (!entry.accounts || !entry.accounts.length)"
                                        class="is-full-width is-flex is-justify-content-center">
                                        <span @click="openClassifyTree(iEntry)"
                                            class="square_pill pill_clasificar is-clickable">
                                            <EditPencil class="edit_pencil" />
                                            Clasificar
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <td class="py-3 px-2 is-vcentered">
                                <div v-for="(type, index) in types" v-bind:key="index" class="mt-1">
                                    <p v-if="entry.attribute[type]" class="is-capitalized attribute_name">{{ type }}:
                                    </p>
                                    <div v-for="(attrib, iAttrib) in entry.attribute[type]" v-bind:key="iAttrib">
                                        <span
                                            :class="['circle_pill', { 'blue_pill': index == 0 }, { 'purple_pill': index == 1 }, 'is-capitalized', 'nobreak']"
                                            v-if="entry.attribute[type].findIndex(att => att.name == attrib.name) == iAttrib">
                                            {{ attrib.name }}
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <td class="py-3 px-2 is-vcentered has-text-centered is-clickable"
                                v-if="!readOnly && counterpart.obligation_name != 'finiquitos-clf' && !entry.cancelled"
                                @click="openClassifyTree(iEntry)">
                                <EditPencil class="mr-1" />
                            </td>
                        </tr>
                        <tr class="counterpart_row" v-bind:key="'extra' + entry.td_id" v-if="!readOnly && entry.isClassifying">
                            <td colspan="10">
                                <div class="p-5 content-tree">
                                    <TreeClassification :classifiedAccounts="selectedClassifiedAccounts"
                                        :accounts="accounts" :types="types"
                                        :classifiedAttributes="selectedClassifiedAttributes"
                                        :allAttributes="allAttributes" :documentType="counterpart.pay_or_charge"
                                        :contraparteId="counterpart.ci_id" :documentsIds="selectedDocumentsIds"
                                        :money="entry.amount" :obligationName="counterpart.obligation_name"
                                        @close-tree="() => closeClassifyTree()" @reload-docs="() => $emit('reload-docs')"
                                        key="prorateEditKey1" />
                                </div>
                            </td>
                        </tr>
                    </template>

                </table>
            </div>
            <Pagination class="mt-3" v-model="actualPage" :maxPages="maxPages" />
        </section>
    </div>
</template>


<script>
import ChangeAccrual from "@/components/classification/modals/ChangeAccrual";
import AccrualViewer from "@/components/classification/modals/AccrualViewer";
import TreeClassification from "@/components/classification/TreeClassificator.vue";
import ProgressCards from "@/components/classification/ProgressCards.vue";
import DocsFilterToolbar from "@/components/classification/DocsFilterToolbar.vue";
import SortButton from "@/components/modals/SortButton.vue";
import Pagination from "@/components/generics/Pagination";
import CalendarCheck from "@/components/svg/CalendarCheck.vue";
import CalendarMinus from "@/components/svg/CalendarMinus.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import { parseToMoney } from "@/utils/currency";
import {
    sortPartiallyDocs,
    matchesFilterTable,
    matchesSearch,
    formatDocDate,
} from "@/utils/classifyDocsSort";
import { notificate } from "@/utils/message";
import { truncateLabel, labelTooltip } from "@/utils/truncate";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
    name: "ClassifyDocuments",
    components: {
        EditPencil,
        SortButton,
        TreeClassification,
        ProgressCards,
        DocsFilterToolbar,
        CalendarCheck,
        CalendarMinus,
        Pagination
    },
    data() {
        return {
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
            //-----
            filterTable: 'all',
            orderedEntries: [],
            searchFilter: "",
            sortColumn: "order",
            sortDirection: "",
            allSelected: false,
            selectedClassifiedAttributes: [],
            selectedClassifiedAccounts: [],
            selectedDocumentsIds: [],
            actualPage: 1,
            itemsPerPage: 10,
            // One-shot del deep-link: se consume en el primer rebuild de
            // orderedEntries con datos, para no secuestrar interacciones
            // posteriores del usuario (sorts/filtros/reloads).
            autoOpenConsumed: false,
        };
    },
    methods: {
        ...mapActions("classification", ["setSelectedHeaderDocTable",
            "setEmptyDocuments", "fetchProratesByCounterpart", "getDocAccruals"]),
        truncateLabel,
        labelTooltip,
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        onChangeAllCheck({ checked }) {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.selected = checked
                return entry
            })
        },
        async openAccrualModal(initialPos) {
            // Solo lectura (libro mayor): el devengo no se edita, pero si el
            // documento tiene devengo se abre un visualizador con el detalle
            // (cuenta × mes × %). Sin devengo, la celda no hace nada.
            if (this.readOnly) {
                const entry = this.getPaginatedList.at(initialPos)
                if (!entry || !entry.has_accrual) {
                    return
                }
                const accruals = await this.getDocAccruals(entry.td_id)
                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: AccrualViewer,
                    width: "90%",
                    canCancel: ["escape", "button", "outside"],
                    props: {
                        titleModal: this.counterpart.alias,
                        // El RUT del mayor es siempre el placeholder: no se muestra.
                        subTitleModal: "",
                        docNumber: entry.doc_number,
                        documentType: this.counterpart.pay_or_charge,
                        docAmount: entry.amount,
                        accruals,
                    },
                })
                return
            }
            if (this.getPaginatedList.at(initialPos).cancelled) {
                return
            }

            const foundEntry = this.orderedEntries.find(entry=> entry.td_id == this.getPaginatedList.at(initialPos).td_id)
            if(foundEntry){
                foundEntry.selected = true
            }
            const allDocsSelected = this.getDocsSelected()

            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ChangeAccrual,
                canCancel: ["escape", "button", "outside"],
                props: {
                    titleModal: this.counterpart.alias,
                    subTitleModal: this.counterpart.rut,
                    documentType: this.counterpart.pay_or_charge,
                    documents: allDocsSelected,
                },
                events: {
                    save_accrual: ({ docs_ids, start_dates, end_dates }) => {
                        this.orderedEntries = this.orderedEntries.map(orderEntry => {
                            const docIdSearched = docs_ids.indexOf(orderEntry.td_id)
                            if (docIdSearched >= 0) {
                                orderEntry.has_accrual = true
                                orderEntry.init_accrual = moment(start_dates[docIdSearched]).format('YYYY-MM-DD')
                                orderEntry.end_accrual = moment(end_dates[docIdSearched]).format('YYYY-MM-DD')
                            }
                            orderEntry.selected = false
                            return orderEntry
                        })
                    },
                    close: () => {
                    }
                },
            });
        },
        getDocsSelected() {
            // this.orderedEntries[initialPos]['selected'] = true;
            // this.orderedEntries = [...this.orderedEntries];
            const allDocsSelected = this.orderedEntries.filter(entry => {
                return entry.selected
            })
            return allDocsSelected
        },
        initLoadClassificationData(data) {
            const prorate_x_account = data['prorate_x_account'];
            const prorates_x_attribute = data['prorates_x_attribute'];

            this.selectedClassifiedAttributes = [...prorates_x_attribute];
            this.selectedClassifiedAccounts = []
            for (const pxa of prorate_x_account) {
                this.selectedClassifiedAccounts.push({ id: Number(pxa.id), percentage: pxa.percentage, account: Number(pxa.classified_account) });
            }
            if (this.selectedClassifiedAccounts.length == 0) {
                this.selectedClassifiedAccounts = [...this.classifiedAccounts]
                this.selectedClassifiedAttributes = [...this.classifiedAttributes]
            }
        },
        async openClassifyTree(iDocument) {
            const data = await this.fetchProratesByCounterpart({
                ciId: this.counterpart.ci_id,
                documentId: this.getPaginatedList[iDocument].td_id,
                payOrCharge: this.counterpart.pay_or_charge,
                obligation: this.counterpart.obligation_name,
            });
            this.initLoadClassificationData(data)

            const foundEntry = this.orderedEntries.find(entry=> entry.td_id == this.getPaginatedList.at(iDocument).td_id)
            if(foundEntry){
                foundEntry.selected = true
            }

            const allDocsSelected = this.getDocsSelected()
            this.selectedDocumentsIds = allDocsSelected.map(docSelected => docSelected.td_id)
            const doc = this.getPaginatedList[iDocument]
            this.orderedEntries = this.orderedEntries.map(entry => {
                if (entry.td_id == doc.td_id) {
                    entry.isClassifying = true
                } else {
                    entry.isClassifying = false
                }
                return entry
            })
        },
        closeClassifyTree() {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.isClassifying = false
                entry.selected = false
                return entry
            })
        },
        // Deep-link desde reportes: cuando orderedEntries se puebla, busca el
        // doc pedido, salta a su página, abre su árbol de prorrateo y lo
        // scrollea a la vista (el scroll burbujea al contenedor del modal).
        async maybeAutoOpen() {
            if (!this.autoOpenDocId || this.autoOpenConsumed) return;
            const visibles = this.orderedEntries.filter(entry => entry.visible)
            if (visibles.length == 0) return; // docs aún no cargados — esperar
            // Esperar el set ENRIQUECIDO (setExtraInfoDocumentsByCounterpart
            // agrega mother_accounts): los buckets —y por lo tanto la página
            // del doc— se calculan distinto sobre el set crudo (un doc
            // clasificado por contraparte ahí no tiene accounts todavía).
            if (visibles[0].mother_accounts === undefined) return;
            this.autoOpenConsumed = true;
            const idx = visibles.findIndex(entry => entry.td_id == this.autoOpenDocId)
            if (idx < 0 || visibles[idx].cancelled) {
                notificate(
                    `<strong>Atención</strong><br>
                    El documento no está disponible en el período cargado.`,
                    "is-warning is-light"
                );
                return;
            }
            this.actualPage = Math.floor(idx / this.itemsPerPage) + 1;
            await this.openClassifyTree(idx % this.itemsPerPage);
            await this.$nextTick();
            const treeEl = this.$el.querySelector(".content-tree");
            if (treeEl && treeEl.scrollIntoView) {
                treeEl.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
        onSelectFilter(value) {
            this.filterTable = value;
            this.allFiltersToEntries();
        },
        changeDirectionData() {
            if (this.sortDirection == "order") {
                this.sortDirection = "desc";
            } else if (this.sortDirection == "desc") {
                this.sortDirection = "asc";
            } else if (this.sortDirection == "asc") {
                this.sortDirection = "order";
                this.sortColumn = "order";
            }
        },
        sortAllDocuments() {
            // El store reemplaza los docs por CLONES al enriquecerlos
            // (setExtraInfoDocumentsByCounterpart) y en cada reload — esos
            // clones no traen isClassifying, así que un rebuild cerraría el
            // árbol abierto. Preservamos el estado por td_id para que el árbol
            // sobreviva (clave para el auto-open del deep-link, que abre sobre
            // el primer set de docs y debe seguir abierto tras el segundo).
            const classifyingIds = new Set(
                this.orderedEntries
                    .filter(entry => entry.isClassifying)
                    .map(entry => entry.td_id)
            )
            const documentsClassified = this.allDocumentsByCounterpart.filter(localDoc => localDoc.accounts.length > 0 && !localDoc.cancelled)
            const documentsNotClassified = this.allDocumentsByCounterpart.filter(localDoc => localDoc.accounts.length == 0 && !localDoc.cancelled)
            const documentsAnnulled = this.allDocumentsByCounterpart.filter(localDoc => localDoc.cancelled)
            const orderedDocsClassified = sortPartiallyDocs(documentsClassified, this.sortColumn, this.sortDirection, this.types)
            const orderedDocsNotClassified = sortPartiallyDocs(documentsNotClassified, this.sortColumn, this.sortDirection, this.types)
            const orderedDocsAnnulled = sortPartiallyDocs(documentsAnnulled, this.sortColumn, this.sortDirection, this.types)
            // Copias (no refs de allDocumentsByCounterpart, que es state de Vuex):
            // a partir de acá orderedEntries son objetos locales y las mutaciones
            // de selected/isClassifying/visible no tocan el store.
            this.orderedEntries = [...orderedDocsNotClassified, ...orderedDocsClassified, ...orderedDocsAnnulled].map(entry => {
                return { ...entry, isClassifying: classifyingIds.has(entry.td_id) }
            })
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                this.sortDirection = "order"
                this.sortColumn = column;
            }
            this.changeDirectionData();
            this.sortAllDocuments();
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            return formatDocDate(emittedDate, format);
        },
        // addedExtraInfoDocuments() {
        //     this.setExtraInfoDocumentsByCounterpart({
        //         alias: this.counterpart.alias,
        //         rut: this.counterpart.rut,
        //         classifiedAccounts: this.classifiedAccounts,
        //         classifiedAttributes: this.classifiedAttributes,
        //         attributes: this.allAttributes
        //     })
        // },
        allFiltersToEntries() {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.isClassifying = false
                entry.visible = matchesSearch(entry, this.searchFilter) &&
                    matchesFilterTable(entry, this.filterTable)

                return entry
            })
            if(this.getPaginatedList.length ==0){
                this.actualPage = 1
            }
        }
    },
    computed: {
        ...mapState("classification", ["selectedCounterpart", "selectedHeaderDocsTable",
            "allDocumentsByCounterpart"]),
        // Vista de empresa acumulada: cada documento muestra su empresa de
        // origen y el badge intercompañía (los datos vienen del backend).
        // Lectura defensiva del store: los specs montan sin él.
        isConsolidatedCompany() {
            const state = this.$store && this.$store.state.userAuth;
            return Boolean(state && state.company && state.company.is_consolidated);
        },
        getNumberClassifiedByCounterpart() {
            let numberClassified = 0
            this.orderedEntries.map(oEntry => {
                if (oEntry.is_classified_by_counterpart && oEntry.accounts.length > 0) {
                    numberClassified++
                }
            })
            return numberClassified
        },
        getNumberClassifiedByDocument() {
            let numberClassified = 0
            this.orderedEntries.map(oEntry => {
                if (!oEntry.is_classified_by_counterpart && oEntry.accounts.length > 0 && !oEntry.cancelled) {
                    numberClassified++
                }
            })
            return numberClassified
        },
        getNumberTotalDocuments() {
            let totalDocs = 0
            this.orderedEntries.map(oEntry => {
                if (!oEntry.cancelled) {
                    totalDocs++
                }
            })
            return totalDocs
        },
        maxPages: function () {
            const newList = this.orderedEntries.filter(entry => entry.visible)
            if (newList.length % this.itemsPerPage == 0) {
                return newList.length / this.itemsPerPage
            }
            return Math.trunc(newList.length / this.itemsPerPage) + 1
        },
        getPaginatedList: function () {
            const startIndex = (this.actualPage - 1) * this.itemsPerPage
            const endIndex = this.actualPage * this.itemsPerPage
            const newList = this.orderedEntries.filter(entry => entry.visible)
            return newList.slice(startIndex, endIndex)
        },
    },
    mounted() {
        // this.addedExtraInfoDocuments()
        this.changeOrderGeneric('amount')
        if (this.allDocumentsByCounterpart.length > 0) {
            this.setSelectedHeaderDocTable(this.allDocumentsByCounterpart[0].doc_type)
        }
    },
    beforeDestroy() {
        this.setEmptyDocuments({ type: 'all' })
    },
    watch: {
        searchFilter() {
            this.allFiltersToEntries()
        },
        classifiedAccounts() {
            // this.addedExtraInfoDocuments()
            this.sortAllDocuments();
        },
        allDocumentsByCounterpart() {
            // this.addedExtraInfoDocuments()
            this.sortAllDocuments()
        },
        orderedEntries() {
            this.maybeAutoOpen()
        }

    },
    props: {
        types: { type: Array, default: () => [] },
        classifiedAccounts: { type: Array, default: () => [] },
        accounts: { type: Array, default: () => [] },
        classifiedAttributes: { type: Array, default: () => [] },
        allAttributes: { type: Array, default: () => [] },
        counterpart: { type: Object, default: () => ({}) },
        // td_id a auto-expandir al cargar (deep-link desde reportes).
        autoOpenDocId: { type: Number, default: null },
        // Solo lectura (libro mayor / ERP): oculta checkboxes, lápiz de
        // clasificar, la pill "Clasificar" y deshabilita editar el devengo. La
        // tabla y el devengo se siguen mostrando igual que en el clasificador.
        readOnly: { type: Boolean, default: false },
    }
};
</script>

<style scoped lang="scss">
.modal_back_caa {
    background-color: #fcfcfd;
}

.gap-custom {
    gap: 24px;
}

.card-custom {
    padding: 12px 24px;
    border-radius: 12px;
    border: 1px solid #EAECF0;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .header-card {
        color: #344054;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 12px;
    }

    .progressTextContent {
        color: #475467;
        font-size: 12px;
        line-height: 20px;

        .numberProgress {
            font-weight: 700;
        }

        .textProgress {
            font-weight: 400;
        }
    }
}

.progress-container {
    width: 100%;
    height: 8px;
    background-color: #EAECF0;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #00A9AD;
    transition: width 0.3s ease-in-out;
}

.header_title {
    width: 100%;
    position: relative;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #101828;
    text-align: left;
    display: inline-block;
}

.header_subtitle {
    width: 100%;
    position: relative;
    font-size: 14px;
    line-height: 20px;
    color: #475467;
    text-align: left;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.container_table_main_table {
    border-radius: 8px;
    overflow: auto;
    border: 1px solid #eaecf0;
}

.main_table {
    border-collapse: collapse;
}

.big_table {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    display: flex;
    flex-direction: row;
}

.absolute-box {
    position: relative;
    min-width: 200px;
    min-width: 300px;

    .absolute-pos {
        position: absolute;
        top: 0;
        left: 0;
        padding: 8px;
        z-index: 5;
    }

    .icon-left {
        height: 20px;
    }

    .input-center {
        margin-left: 28px;
        z-index: 2;
        border-width: 0;
        width: 80%;
        background-color: transparent;
    }

    .input-center:focus {
        outline: none;
        border-color: transparent;
        box-shadow: none;
    }

    .icon-right {
        height: 20px;
        right: 0px;
        left: auto;
    }
}

.search_container {
    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.filter_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0;
    flex: 2;
}

.ecs {
    width: 100%;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.clear_button {
    // position: relative;
    // left: -60px;
    // top: 16px;
    // transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #888;
    z-index: 2;
}

$select_transition: 0.1s;

.select_button {
    text-align: center;
    border-radius: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: 0.5px solid #ccc;
    border-left: 0.5px solid #ccc;
    margin: 0;
    padding: clamp(5px, 6px, 8px) clamp(10px, 12px, 16px);
    background-color: #ffffff;
    color: #000000;
    transition: all $select_transition ease;
}

.select_button:first-of-type {
    border-left: 1px solid #ccc;
}

.select_button:last-of-type {
    border-right: 1px solid #ccc;
}

.select_button:hover {
    background-color: #c7c7c7;
    color: #000000;
    transition: all $select_transition ease;
}

.first_button {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.last_button {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.black_button {
    background-color: #002e33 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

.black_button:hover {
    background-color: #185555 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}


.table_header_title {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
}

// Columna ordenable: todo el header es clickeable (no solo el ícono), para que
// aplicar el orden sea obvio. El SortButton indica la dirección activa.
.sortable_header {
    cursor: pointer;
    user-select: none;

    &:hover {
        color: #101828;
    }
}

// La etiqueta puede truncar (columnas angostas como Mes Devengo / Rut); el
// ícono de orden nunca se encoge ni se recorta, así siempre queda visible.
.header_label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sort_btn {
    flex-shrink: 0;
}

.color_gray_text {
    color: #475467;
}

.nobreak {
    white-space: preserve nowrap;
}

.counterpart_row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;
}

// Fila con el árbol de clasificación abierto (lápiz presionado): fondo igual al
// hover de la tabla de Estado de Resultados del reporte financiero
// (--report-accent-bg = #edfdfe). Va en los td para pintar toda la fila.
.counterpart_row.is-classifying > td {
    background-color: #edfdfe;
}

.content-tree {
    border-bottom: 1px solid #EAECF0;
    background: #F9FAFB;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.attribute_name {
    color: #344054;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
}

.circle_pill {
    position: relative;
    border-radius: 16px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    width: min-content;
    min-width: 4em;
}

.blue_pill {
    color: #026AA2;
    border: 1px solid #B9E6FE;
    background: #F0F9FF;
}

.purple_pill {
    color: #5925DC;
    border: 1px solid #D9D6FE;
    background: #F4F3FF;
}

.square_pill {
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    justify-content: center;
    padding: 2px 4px;
    text-align: center;
    font-size: 12px;
    width: min-content;
    min-width: 4em;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_mother_account {
    line-break: auto;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}


.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.white_pill {
    background-color: #FFF;
    border: 1px solid #D0D5DD;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

.checkSize {
    width: 20px;
    height: 20px;
    // Color del check seleccionado (header "todos" + por fila).
    accent-color: #0097cd;
}

// Vista acumulada: empresa de origen del documento + badge intercompañía.
.doc-owner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 2px;
    font-size: 10.5px;
    font-weight: 600;
    color: var(--report-accent, #0d7d80);
    white-space: nowrap;
}

.intercompany-badge {
    padding: 0 7px;
    border-radius: 999px;
    background-color: var(--report-warning-wash, rgba(192, 122, 30, 0.12));
    color: var(--report-warning, #a05c14);
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.is-vcentered {
    vertical-align: middle !important;
}

.iconAlign {
    margin-bottom: -2px;
}
</style>
